window.main_consultant_runner = function() {
  if (!bowser.ie) {
    $('body').append('<script src="http://consultant.zenonline.ru/init"></script>')
  }
}
